module.exports = "ul {\r\n  padding: 0;\r\n  list-style-type: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/publishers/competition-timeband/competition-timeband.component.css
// module id = ./src/app/publishers/competition-timeband/competition-timeband.component.css
// module chunks = main